import "jquery-ui/themes/base/all";

import $ from "jquery";
import "jquery-ui";
import "air-datepicker/dist/js/datepicker.min.js";
import "jquery-ui/ui/widgets/autocomplete";
import "jquery-ui/ui/widgets/selectmenu";
import {} from "jquery-ujs";

import "../../components/desktop/searchfield/languages/datepicker.se";
import "air-datepicker/dist/css/datepicker.min.css";

import iFrame from "../../components/desktop/iframe";

$(document).ready(function() {
  $("#search_type_radio_return").prop("checked", true);
  iFrame.load();
});
